<template>
  <b-form-group label="Tên nhân viên" v-click-outside="hideStaffWithDelay">
    <div style="display: -webkit-box">
      <b-form-input
        v-model="staffId"
        @input="fetchStaffOptions"
        @focus="actionFocusSearchEmployee"
        :debounce="500"
        class="form-control f12 hc-37"
        autocomplete="off"
        placeholder="Tìm kiếm nhân viên"
      />
      <b-spinner label="Spinning" small class="m-t-10 ml-2" v-if="loadingStaff"></b-spinner>
    </div>

    <div class="search-staff" v-if="showDropdown">
      <div v-if="!loadingStaff" class="scrollable-container">
        <template v-if="staffIdOptions.length > 0">
          <div class="add-user">
            <b-list-group-item
              v-for="(user, index) in staffIdOptions"
              :key="index"
              @click="addStaff(user)"
              class="d-flex justify-content-between align-items-center staff-user"
            >
              <div class="au-detail">
                <span><img src="@/assets/img/avatar1.png" /></span>
                <article>
                  <p>
                    <span class="username mr-2">{{ user.name }}</span
                    ><br />
                    <span class="username mr-2">{{ user.userName }}</span>
                  </p>
                  <b>{{ user.roles ? user.roles[0] : '' }}</b>
                </article>
              </div>
            </b-list-group-item>
          </div>
        </template>
        <div v-else class="add-user no-data p-3" style="width: 200px">Không có dữ liệu</div>
      </div>
    </div>
  </b-form-group>
</template>

<script>
  import { debounce } from 'vue2-debounce'
  import { showMess } from '@/config/utils'
  import { SearchStaffInferior } from '@/services/customer-support/staff'

  export default {
    props: {
      selectedRegion: {
        type: String,
        default: null,
      },
      selectedPosition: {
        type: String,
        default: null,
      },
      excludeIds: {
        type: Array,
        default: function () {
          return []
        },
      },
    },
    data() {
      return {
        staffId: '',
        loadingStaff: false,
        showDropdown: false,
        staffIdOptions: [],
        loading: false,
      }
    },

    directives: {
      'click-outside': {
        bind: (el, binding, vnode) => {
          el.clickOutsideEvent = event => {
            if (!(el == event.target || el.contains(event.target))) {
              vnode.context[binding.expression](event)
            }
          }
          document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unbind: el => {
          document.body.removeEventListener('click', el.clickOutsideEvent)
        },
      },
    },

    methods: {
      fetchStaffOptions: debounce(async function () {
        try {
          this.loadingStaff = true
          this.showDropdown = true
          const getListParams = {
            limit: 10,
            keyWord: this.staffId,
          }
          if (this.selectedRegion) {
            getListParams.region = this.selectedRegion
          }
          if (this.selectedPosition) {
            getListParams.typeSale = this.selectedPosition
          }
          if (this.excludeIds.length > 0) {
            getListParams.excludeIds = this.excludeIds
          }
          const res = await SearchStaffInferior(getListParams)
          this.staffIdOptions = res.data
        } catch (error) {
          showMess(this, 'Thông báo', error.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loadingStaff = false
        }
      }, 500),

      actionFocusSearchEmployee() {
        if (this.staffIdOptions.length > 0 && this.staffId != '') {
          this.showDropdown = true
        } else {
          this.staffIdOptions = []
          this.showDropdown = false
          this.fetchStaffOptions()
        }
      },

      hideStaffWithDelay() {
        this.showDropdown = false
      },

      addStaff(user) {
        this.$emit('addStaff', user)
        this.showDropdown = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .staff-user {
    cursor: pointer;
  }

  .search-staff {
    position: absolute;
    z-index: 1100;
    margin-top: 5px;
    border: 1px solid rgba(0, 0, 0, 0.125);

    .no-data {
    }
  }

  .scrollable-container {
    max-height: 200px;
    overflow-y: scroll;
    border-radius: 5px;
  }

  .au-detail {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 5px;

    &:hover {
      background: #00000021;
    }

    & > span {
      display: inline-block;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;
      width: 30px;
    }

    & > article {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(100% - 60px);

      p {
        margin-bottom: 0;
        line-height: 15px;
        color: #333;
        font-weight: 700;
        & > span {
          font-weight: normal;
        }
      }

      b {
        text-align: right;
        color: #13569f;
      }
    }
  }

  .list-group-item {
    padding: 0;
  }

  .add-user {
    width: 325px;
    background: #fff;
    box-shadow: 0px 0px 10px -6px;
    top: 50px;
    ul {
      max-height: 300px;
      overflow: auto;
    }
  }
</style>
